module.exports = __webpack_public_path__ + "static/media/ajax-Loader.89f31662.gif";